<template>
  <div class="d-flex flex-column">
    <div class="mfa-qrcode-top-wrapper">
      <QrcodeVue
        v-bind:value="getQRCodeValue"
        v-bind:size="160"
        foreground="#000000"
        background="#DCDCDC"
        level="M"
        style="padding: 20px 20px 13px 20px;"
      >
      </QrcodeVue>

      <img
        src="../../../assets/images/smalltw-light.png"
        class="vb-logo"
      />
    </div>

    <div class="mfa-qrcode-bottom-wrapper text-uppercase" style="">
      <b>tubeway.io</b>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name:"MFAQRCode",
  components: {
    QrcodeVue,
  },
  props: {
    totpCode: String,   // the code
    user: Object,       // the Cognito user
  },
  watch: {
    // totpCode: function(newCode) {
    //   console.log("New totp code", newCode);
    // }
  },
  computed: {
    getQRCodeValue: function() {
      let str = '';
      if (this.user && this.user.username) {
        const email = this.user.username;
        const label = encodeURIComponent("Tubeway:" + email);
        str = "otpauth://totp/" + label + "?secret=" + this.totpCode + "&issuer=Tubeway";
      }

      return str;
    },
  }
}
</script>

<style scoped>
.mfa-qrcode-top-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color:#DCDCDC;
  border: 2px solid #3dabff;
  border-radius: 8px 8px 0px 0px;
}

.mfa-qrcode-top-wrapper > .vb-logo {
  display: block;
  position: relative;
  width: 30px;
  height: 30px;
  margin-top: -98px;
  margin-bottom: 68px;
  background-color: #DCDCDC;    /* This could be removed for some transparent images. */
}

.mfa-qrcode-bottom-wrapper {
  background-color: #3dabff;
  color: #191919;
  font-size: 11px;
  text-align: center;
  letter-spacing: 1px;
  border-radius: 0px 0px 8px 8px;
}
</style>
